export default __webpack_public_path__ + "static/media/ASSA.0817a2c6.svg";